import type { ProductVariant } from 'data/product'
import { slug } from 'lib/utils'

export const BOTTLE_PATH = '/bottle/'
export const MEET_PATH = '/meet/'

export const urlWithVariant = (
  path: typeof BOTTLE_PATH | typeof MEET_PATH,
  currentVariant: Pick<ProductVariant, 'slug'>
) =>
  path === BOTTLE_PATH || path === MEET_PATH
    ? [path, slug(currentVariant.slug), '/'].join('')
    : path

export const isPathActive = (path: string, locationPathname: string) =>
  path === BOTTLE_PATH || path === MEET_PATH
    ? locationPathname.startsWith(path)
    : path === locationPathname

// only use full routes on bottle and meet pages since the selected variant is hard-coded into the URL
// otherwise, we get href mismatches on other pages because the variant is in session storage.
export const smartUrlWithVariant = (
  path: string,
  currentVariant: Pick<ProductVariant, 'slug'>,
  locationPathname: string
) => {
  const isActiveBottle = isPathActive(BOTTLE_PATH, locationPathname)
  const isActiveMeet = isPathActive(MEET_PATH, locationPathname)

  const isBottleLink = path === BOTTLE_PATH
  const isMeetLink = path === MEET_PATH

  if ((isActiveBottle || isActiveMeet) && (isBottleLink || isMeetLink)) {
    return urlWithVariant(path, currentVariant)
  }

  return path
}
